<template>
  <v-container fluid ma-0 pa-0>
    <CaseConfigHeader header="Notifications" subheader="Your latest notifications from Caseblocks."></CaseConfigHeader>
    <v-tabs grow slider-color="primary" class="notifications-tabs px-4">
      <v-tab ripple>Notifications</v-tab>
      <v-tab ripple>Cases you're listening to</v-tab>
      <v-tab-item>
        <div class="px-4 pt-4 pb-2" v-if="hasNotifications">
          <v-btn @click="clearAllNotifications()" flat class="ma-0 text-link-button">
            <v-icon class="mr-2">clear_all</v-icon>Clear all
          </v-btn>
        </div>
        <div v-if="hasNotifications" class="">
          <NotificationDay v-for="(day, index) in recentNotifications" :key="index" :day="day"></NotificationDay>
          <v-tooltip color="secondary" right>
            <v-btn dark slot="activator" color="secondary" class="mt-3 ml-0" v-if="hasMoreNotifications"
              @click="loadMore">
              <v-icon class="mr-2">keyboard_arrow_down</v-icon>Load more
            </v-btn>
            <span>Load more</span>
          </v-tooltip>
        </div>
        <div v-else>
          <h4 class="mt-4 mx-2">There are currently no more notifications!</h4>
        </div>
      </v-tab-item>
      <v-tab-item>
        <v-layout wrap row class="mt-3">
          <CaseCard v-for="(cas, index) in subscribedCases" :key="index" :case-data="cas"></CaseCard>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import NotificationDay from "@/components/notifications/NotificationDay"
import CaseConfigHeader from "@/components/cases/case-config/CaseConfigHeader.vue"
import CaseCard from "@/components/CaseCard.vue"
import Vue from "vue"

export default {
  name: "Notifications",
  components: { NotificationDay, CaseCard, CaseConfigHeader },
  mounted() {
    Vue.store.dispatch("setPageTitle", "Notifications")
  },
  computed: {
    ...mapState({
      caseTypes: (state) => state.caseTypes.all,
      notifications: (state) => state.currentUser.notifications,
      recentNotifications: (state) => state.currentUser.recentNotifications,
      caseNotifications: (state) => state.currentUser.caseNotifications,
      subscriptions: (state) => state.currentUser.subscriptions,
      userId: (state) => state.currentUser.me.id,
    }),
    subscribedCases() {
      const cases = []
      if (this.subscriptions) {
        const allCases = this.subscriptions.map((sub) => sub.case) // Contains duplicate cases...
        const ids = allCases.map((sub) => sub.id)
        const subscribedCaseIds = ids.filter(
          (val, index, array) => array.indexOf(val) === index
        ) // Filter out duplicates
        subscribedCaseIds.forEach((caseId) => {
          const currentCase = allCases.find((kase) => kase.id === caseId) // Get case by Id
          const caseType = this.caseTypes.find(
            (ct) => ct.id === currentCase.caseTypeId
          ) // get CaseType (for Icon)
          cases.push({
            id: currentCase.id,
            title: currentCase.title,
            caseTypeId: currentCase.caseTypeId,
            caseType: currentCase.caseType,
            currentState: currentCase.currentState,
            sla: "",
            slaState: "",
            icon: { set: caseType.iconSet, code: caseType.iconCode },
          })
        })
      }
      return cases
    },
    hasNotifications() {
      return (this.recentNotifications && this.recentNotifications.length > 0) || (this.notifications && this.notifications.length > 0)
    },
    hasCaseNotifications() {
      return this.caseNotifications.length > 0
    },
    hasMoreNotifications() {
      return false // TODO - pagination
    },
  },
  methods: {
    preferencesRoute: (userId) => `/users/${userId}/Notifications`,
    loadMore() {
      // TODO - pagination
      console.log("Get more notifications!")
    },
    clearAllNotifications() {
      this.$store.dispatch("clearAllNotifications")
    },
  },
}
</script>

<style>
.notifications-tabs .theme--light.v-tabs__bar {
  background: none !important;
  border-bottom: solid thin rgba(0, 0, 0, 0.12);
}
</style>
